import { useMutation } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useReleaseEntityLeaseMutation = (onError?: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (entityLeaseId: string) => {
            const response = await zoneApiClient.releaseEntityLease(entityLeaseId);

            if (!response?.httpResponse.ok) {
                if (response.errorMessage && response.httpResponse.status == 400) {
                    if (response.errors !== undefined && response.errors[0] !== undefined) {
                        throw new Error(
                            `Failed to release the current lease : ${response.errors[0].message}`
                        );
                    }
                }
                throw new Error('Failed to release the current lease');
            }
            return response.payload;
        },
        onError(error) {
            if (error instanceof Error && typeof onError === 'function') {
                onError(error.message);
            }
        },
    });
}
    